import { createErrorHandler, ErrorEvent, EventHint, init, replayIntegration } from '@sentry/angular'
import { environment } from '@env'
import { ErrorHandler, isDevMode, provideAppInitializer } from '@angular/core'
import { ApiErrorResponse } from '@sun-finance/utils'

// Requests to the API look like {apiUrl}/{auth|anon}/{service}/...
const serviceName = (error: ApiErrorResponse): string | null => {
  const url = error.original?.url

  if (!url?.startsWith(environment.apiUrl)) {
    return null
  }

  return url.slice(environment.apiUrl.length).split('/')[2] || null
}

const tagHttpError = (event: ErrorEvent, hint: EventHint): ErrorEvent => {
  const error = hint.originalException

  if (!(error instanceof ApiErrorResponse)) {
    return event
  }

  event.tags = { ...event.tags, 'http.status': error.status }

  const service = serviceName(error)

  if (service) {
    event.tags['http.service'] = service
  }

  return event
}

export const providers = [
  provideAppInitializer(() => {
    if (isDevMode()) return

    init({
      dsn: environment.sentryDsn,
      environment: environment.sentryEnv,
      integrations: [replayIntegration()],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1,
      sendDefaultPii: true,
      beforeSend: tagHttpError,
    })
  }),
  {
    provide: ErrorHandler,
    useValue: createErrorHandler(),
  },
]
